import { render, staticRenderFns } from "./ErpTemplate.vue?vue&type=template&id=e08516b8&scoped=true"
import script from "./ErpTemplate.vue?vue&type=script&lang=js"
export * from "./ErpTemplate.vue?vue&type=script&lang=js"
import style0 from "./ErpTemplate.vue?vue&type=style&index=0&id=e08516b8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e08516b8",
  null
  
)

export default component.exports